// extracted by mini-css-extract-plugin
export default {"g":"WorkflowLine_g__w6fKf"};